import clamp from 'lodash/clamp';

// restrict lengths to between min and max values
export const clampWithLimit = (
  value: number,
  { MIN, MAX }: { MIN: number; MAX: number }
): number => clamp(value, MIN, MAX);
